import { LoaderFunction } from "react-router-dom";
import { axiosApi } from "../../../interceptors/axios";
import { Result } from "../../../types/Result";
import { ExamType } from "../../examType/type";

export const examSummaryLoader: LoaderFunction = async () => {
  const result = await axiosApi.get<Result<ExamType>>("/api/examTypes/summary");

  return result.data;
};
